var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 游戏详情 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }